import  {  getPdfFilenameFromUrl  }  from "pdfjs-lib";


async  function  docProperties(pdfDocument)  {

  const  url  = "",

    baseUrl  =  url.split("#",  1)[0];

  // eslint-disable-next-line prefer-const
  let  {  info,  metadata,  contentDispositionFilename,  contentLength  }  =

    await  pdfDocument.getMetadata();


  if  (!contentLength)  {

    const  {  length  }  =  await  pdfDocument.getDownloadInfo();

    contentLength  =  length;

  }


  return  {

    ...info,

    baseURL:  baseUrl,

    filesize:  contentLength,

    filename:  contentDispositionFilename  ||  getPdfFilenameFromUrl(url),

    metadata:  metadata?.getRaw(),

    authors:  metadata?.get("dc:creator"),

    numPages:  pdfDocument.numPages,

    URL:  url,

  };

}


class  GenericScripting  {

  constructor(sandboxBundleSrc)  {

    this._ready  =  new  Promise((resolve,  reject)  =>  {

      const  sandbox  =

        typeof  PDFJSDev  === "undefined"

          ?  import(sandboxBundleSrc)  // eslint-disable-line no-unsanitized/method
          :  __non_webpack_import__(sandboxBundleSrc);

      sandbox

        .then(pdfjsSandbox  =>  {

          resolve(pdfjsSandbox.QuickJSSandbox());

        })

        .catch(reject);

    });

  }


  async  createSandbox(data)  {

    const  sandbox  =  await  this._ready;

    sandbox.create(data);

  }


  async  dispatchEventInSandbox(event)  {

    const  sandbox  =  await  this._ready;

    setTimeout(()  =>  sandbox.dispatchEvent(event),  0);

  }


  async  destroySandbox()  {

    const  sandbox  =  await  this._ready;

    sandbox.nukeSandbox();

  }

}


export  {  docProperties,  GenericScripting  };